import React, { useEffect } from "react"
import { Application } from "@theguarantors/ui-kit-v2/dist/layout/one-column-form"

import { NoApartmentForm } from "./components/NoApartmentForm"
import { defaultMenuItems, menuItemsForNoApartment } from "../../constants/menu"
import { FeatureFlag, useFeatureFlag } from "../../hooks/use-feature-flag"
import { HeaderV2 } from "@theguarantors/ui-kit-v2/dist/layout/HeaderV2"
import { Footer } from "@theguarantors/ui-kit-v2/dist/layout/one-column-form/Footer"
import { Content } from "@theguarantors/ui-kit-v2/dist/layout/one-column-form/Content"

const NewHeader = () => {
  return (
    <>
      <HeaderV2 couper={[<></>, <></>]} menuItems={menuItemsForNoApartment} />
      <Content data-testid={"test-data"}>
        <NoApartmentForm />
      </Content>
      <Footer />
    </>
  )
}

const OldHeader = () => (
  <Application headerMenuItems={defaultMenuItems}>
    <NoApartmentForm />
  </Application>
)

export const NoApartmentComponent: React.FC = () => {
  const [rebrandV2MonolithReact] = useFeatureFlag(FeatureFlag.REBRAND_V2_MONOLITH_REACT)
  const [noApartmentRedirect] = useFeatureFlag(FeatureFlag.NO_APARTMENT_REDIRECT)
  const rebrandV2MonolithReactFeatureFlag: boolean = rebrandV2MonolithReact === "on"
  const noApartmentRedirectFeatureFlag: boolean = noApartmentRedirect === "on"
  
  useEffect(() => {
    if (noApartmentRedirectFeatureFlag) {
      window.location.replace("https://www.theguarantors.com/no-apartment")
    }
  }, [noApartmentRedirectFeatureFlag])
  
  if(noApartmentRedirectFeatureFlag) { return null; }

  return rebrandV2MonolithReactFeatureFlag ? <NewHeader /> : <OldHeader />
}
